import { Const } from '@/const';

// textarea専用のアンドゥリドゥ
export class TextAreaUndoRedoManager 
{
    public canUndo = false;
    public canRedo = false;

    // スタック
    private undoStack : Array<TextAreaHistory> = [];
    private redoStack : Array<TextAreaHistory> = [];

    // 現在の値
    private currentHistory : TextAreaHistory = new TextAreaHistory();

    // アンドゥ追加
    private addUndo(history : TextAreaHistory)
    {
        this.undoStack.push(history);

        // 古いスタックを削除する
        while(this.undoStack.length > Const.UNDO_STACK_SIZE)
        {
            this.undoStack.splice(0, 1);
        }

        // アンドゥ可能か更新
        this.canUndo = this.undoStack.length > 0;
    }

    // リドゥ追加
    private addRedo(history : TextAreaHistory)
    {
        this.redoStack.push(history);

        // 古いスタックを削除する
        while(this.redoStack.length > Const.UNDO_STACK_SIZE)
        {
            this.redoStack.splice(0, 1);
        }

        // リドゥ可能か更新
        this.canRedo = this.redoStack.length > 0;
    }

    public init(textarea : HTMLTextAreaElement)
    {
        this.currentHistory = new TextAreaHistory();
        this.currentHistory.value = textarea.value;
        this.currentHistory.selectionStart = textarea.selectionStart;
        this.currentHistory.selectionEnd = textarea.selectionEnd;
        this.undoStack = [];
        this.redoStack = [];
        this.canUndo = false;
        this.canRedo = false;
    }

    // 履歴を残す
    public addHistory(textarea : HTMLTextAreaElement) : void
    {
        if(this.currentHistory.value == textarea.value)
        {
            // 値に変化がない場合は現在の選択状態のみ更新
            this.currentHistory.selectionStart = textarea.selectionStart;
            this.currentHistory.selectionEnd = textarea.selectionEnd;
            return;
        }

        // 今までの現在値をアンドゥに追加する
        this.addUndo(this.currentHistory);

        // 現在の値を登録する
        this.currentHistory = new TextAreaHistory();
        this.currentHistory.value = textarea.value;
        this.currentHistory.selectionStart = textarea.selectionStart;
        this.currentHistory.selectionEnd = textarea.selectionEnd;

        // リドゥをクリアする
        this.redoStack = [];
        // リドゥ可能か更新
        this.canRedo = this.redoStack.length > 0;
    }

    // アンドゥを行い、一つ前の状態に戻す
    public undo(textarea : HTMLTextAreaElement) : void
    {
        if(this.undoStack.length > 0)
        {
            // 最新の履歴を取り出す
            var history = this.undoStack.pop();
            if(history == null) return;
            // アンドゥ可能か更新
            this.canUndo = this.undoStack.length > 0;

            // リドゥに現在の状態を送る
            let redoHistory = new TextAreaHistory();
            redoHistory.value = textarea.value;
            redoHistory.selectionStart = textarea.selectionStart;
            redoHistory.selectionEnd = textarea.selectionEnd;
            this.addRedo(redoHistory);
            // 状態を戻す
            this.currentHistory = history;
            setTimeout(() =>
            {
                // 遅延実行しないと値が巻き戻ってしまう
                textarea.value = this.currentHistory.value;
                textarea.setSelectionRange(this.currentHistory.selectionStart, this.currentHistory.selectionEnd);
            }, 1);
        }
    }

    // リドゥを行い、ひとつ後の状態に進める
    public redo(textarea : HTMLTextAreaElement) : void
    {
        if(this.redoStack.length > 0)
        {
            // 最新のコマンドを取り出す
            var history = this.redoStack.pop();
            if(history == null) return;
            // リドゥ可能か更新
            this.canRedo = this.redoStack.length > 0;

            // アンドゥに現在の状態を送る
            let undoHistory = new TextAreaHistory();
            undoHistory.value = textarea.value;
            undoHistory.selectionStart = textarea.selectionStart;
            undoHistory.selectionEnd = textarea.selectionEnd;
            this.addUndo(undoHistory);

            // この履歴に状態を進める
            this.currentHistory = history;
            setTimeout(() =>
            {
                // 遅延実行しないと値が巻き戻ってしまう
                textarea.value = this.currentHistory.value;
                textarea.setSelectionRange(this.currentHistory.selectionStart, this.currentHistory.selectionEnd);
            }, 1);
        }
    }
}

export class TextAreaHistory
{
    public value : string = "";
    public selectionStart : number = 0;
    public selectionEnd : number = 0;
}